import { loadNotes, loadNote } from '../common/api';

const notes = {
    name: 'notes',
    state: { 
        current: {
            details: {},
            assoc: []
        },
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.nid
            }
        },
        cdcInsert: ( state, payload ) => {
            // might receive assoc insert first, so can't assume first time seeing anying for this id
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.nid]: {
                        ...state.byId[payload.nid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcInsertAssoc: ( state, payload ) => {
            const [ nid, oid ] = payload.nid.split( '#' );
            let assoc = [ payload.cdc ];

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [nid]: { 
                        ...state.byId[nid],
                        assoc: assoc
                    }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.nid]: {
                        ...state.byId[payload.nid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.nid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        cdcRemoveAssoc: ( state, payload ) => {
            const [ nid, oid ] = payload.nid.split( '#' );
            if ( !state.byId[nid] ) {
                return {
                    ...state
                }
            }

            let assoc = state.byId[nid].assoc.filter( f => ( f.naid !== payload.nid ) );

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [nid]: { 
                        ...state.byId[nid],
                        assoc: assoc
                    }
                }
            }
        },
        loadedNotes: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        },
        loadedNote: ( state, payload ) => {
            return {
                ...state,
                current: {
                    ...state.current,
                    details: payload.details,
                    assoc: payload.assoc
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadNote( { aid, uid, nid } ) {
            const n = await loadNote( aid, uid, nid );
            n.assoc.forEach( m => {
                m['id'] = m.cid;
            } );
            dispatch.notes.loadedNote( n );
        },
        async loadNotes( { aid, uid } ) {
            const list = await loadNotes( aid, uid );
            let byId = {};
            list.forEach( n => byId[n.nid] = n );
            dispatch.notes.loadedNotes( byId );
        },
        insert( { nid, cdc } ) {
            const assoc = nid.match( '#' );
            if ( assoc ) {
                dispatch.notes.cdcInsertAssoc( { nid, cdc } );
            } else {
                dispatch.notes.cdcInsert( { nid, cdc } );
            }
        },
        modify( { nid, cdc } ) {
            dispatch.notes.cdcModify( { nid, cdc } );
        },
        remove( { nid } ) {
            const assoc = nid.match( '#' );
            if ( assoc ) {
                dispatch.notes.cdcRemoveAssoc( { nid } );
            } else {
                dispatch.notes.cdcRemove( { nid } );
            }
        },
        setCurrent( { nid } ) {
            dispatch.notes.setCurrentId( { nid } );
        }
    } )
}

export default notes;